import styled from 'styled-components';

export const AppHomeHeaderContainer = styled.div`
  background-color: black;
  color: white;
  padding: 26px 22px;

  .nsearch {
    z-index: 26;
  }
  .nsearch2 {
    z-index: 17;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const PassengerDriverSelect = styled.select`
  padding: 12px 18px;
  border-radius: 20px;
  font-size: 12px;
`;

export const HeaderMid = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 35px;
  display: ${({ selectedUser }) =>
    selectedUser === 'DRIVER' ? 'none' : 'flex'};
`;

export const SelectPassengersQTDContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const IncreasePassengersQTDButton = styled.button``;

export const SelectedPassengerNumberDiv = styled.div`
  background-color: white;
  border-radius: 100px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  color: black;
  justify-content: center;
  font-size: 25px;
`;

export const DecreasePassengersQTDButton = styled.button``;

export const SelectAdressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const CategoriesContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow: scroll;
  height: 40px;
  gap: 10px;
  display: ${({ selectedUser }) =>
    selectedUser === 'DRIVER' ? 'none' : 'flex'};
`;

export const CategoryContainer = styled.div`
  display: flex;
  background-color: ${({ isSelected }) => (isSelected ? '#FF4406' : 'white')};
  color: ${({ isSelected }) => (isSelected ? 'white' : 'black')};
  align-items: center;
  justify-content: center;
  padding: 9px 18px;
  border-radius: 20px;
`;
